import * as angular from "angular";
import {IController} from "angular";

export class BringozSkillSelectComponent implements IController {
  skill: any;
  agentType: any;
  isDisabled: any;
  ngRequired: any;
  ngPlaceholder: any;
  noUnderline: any;
  options: any;
  onChange: Function;

  selectOptions: any;
  skillsByType: any;

  constructor(private agentConstants, private $mdSelect) {
  }


  $onInit() {
    this.skillsByType = this.agentConstants.skillsByType;
    this.selectOptions = this.options || this.skillsByType[this.agentType || 'All'];
  };

  $onChanges(changes) {
    if (changes.agentType && !changes.agentType.isFirstChange()) {
      this.selectOptions = this.options || this.skillsByType[this.agentType || 'All'];
    }
  };


  reset() {
    this.onChange({skill: undefined});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozSkillSelect', {
    bindings: {
      skill: '<',
      agentType: '<',
      isDisabled: '<?',
      ngRequired: '@?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      options: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-skill-select/bringoz-skill-select.html',
    controller: BringozSkillSelectComponent
  });
